import React from 'react';
import { motion } from 'framer-motion';
export function ParallaxBanner() {
  return <section className="relative py-32 md:py-48 overflow-hidden flex items-center justify-center" data-id="element-178">
      <div className="absolute inset-0 z-0 parallax" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/jUyqr3bicUZcGmQ1TDgRL7/255.jpg')"
    }} data-id="element-179">
        <div className="absolute inset-0 bg-navy/80 mix-blend-multiply" data-id="element-180" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-181">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-182">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6 uppercase leading-tight" data-id="element-183">
            Immediate Response. <br className="hidden sm:block" data-id="element-184" />
            Accurate Reports. <br className="hidden sm:block" data-id="element-185" />
            <span className="text-accent" data-id="element-186">Unbiased Findings.</span>
          </h2>
          <div className="w-20 h-1 bg-white mx-auto mb-8" data-id="element-187"></div>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-188">
            We work closely with our clients to develop an understanding of
            their particular needs — from damage claims to new construction
            oversight.
          </p>
        </motion.div>
      </div>
    </section>;
}